






























import { Component, Vue } from "vue-property-decorator";
import { deleteSolution, checkDelete } from "@/services/solutions/solutionService";

@Component
export default class SolutionDeleteModal extends Vue {
    boardToBeDeleted: string = "";
    boardName: string = ""
    isSaved: boolean = false;

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") {
            if (this.boardToBeDeleted !== "") this.confirm();
            else this.close();
        }
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.isSaved = false;
        this.boardToBeDeleted = "";
        this.boardName = "";
    }

    open(solutionId: string, name: string) {
        checkDelete(solutionId).then(response => {
            if (response) {
                this.boardToBeDeleted = solutionId;
                this.boardName = name;
                this.$bvModal.show("modal-deleteSolution");
            } else {
                this.$bvModal.show("modal-deleteSolutionNotAllowed");
            }

            window.addEventListener("keydown", this.handleEnter);
        });
    }

    close() {
        this.$bvModal.hide("modal-deleteSolutionNotAllowed");
    }

    decline() {
        this.$bvModal.hide("modal-deleteSolution");
        this.boardToBeDeleted = "";
        this.boardName = "";
    }

    confirm() {
        if (this.isSaved) return;
        this.isSaved = true;
        deleteSolution(this.boardToBeDeleted).then(() => {
            this.$emit("reload");
            this.$bvModal.hide("modal-deleteSolution");
            this.boardToBeDeleted = "";
            this.boardName = "";
        });
    }
}
